(function() {
    var FilterController = {
        elements : {
            triggers : []
        },
        state : {

        },
        handleTriggerClick : function(e) {
            var target = e.currentTarget;
            var triggerString = target.getAttribute('filter-trigger');
            var triggerSegments = triggerString.split('.');
            var controllerSegment = triggerSegments[0];
            var functionSegment = triggerSegments[1];

            var controller = window[controllerSegment];
            if(typeof controller === 'object') {
                var controllerFunction = controller[functionSegment];
                if ( typeof controllerFunction === 'function' ) {
                    controllerFunction(target.getAttribute('filter-group'), target.getAttribute('filter-value'));
                } else {
                    console.error('Could not find function on "' + controllerSegment + '"');
                }
            } else {
                console.error('Could not find controller "' + controllerSegment + '" on window');
            }
        },
        addEventListeners : function() {
            for ( var i = 0; i < this.elements.triggers.length; i++ ) {
                var currentTrigger = this.elements.triggers[i];
                currentTrigger.addEventListener('click', this.handleTriggerClick.bind(this));
            }
        },
        init : function() {
            this.elements.triggers = document.querySelectorAll('[filter-trigger]');

            this.addEventListeners();
        }
    }

    document.addEventListener('DOMContentLoaded', function() {
        FilterController.init();
    });
})();